import { render, staticRenderFns } from "./PassengerflowViewDaHua.vue?vue&type=template&id=17a0ba28&scoped=true"
import script from "./PassengerflowViewDaHua.vue?vue&type=script&lang=js"
export * from "./PassengerflowViewDaHua.vue?vue&type=script&lang=js"
import style0 from "./PassengerflowViewDaHua.vue?vue&type=style&index=0&id=17a0ba28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a0ba28",
  null
  
)

export default component.exports